var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CategoryOverviewSection, DashboardCategory, WidgetCategory } from "./enums";
import { generateRoute } from "@js/common/helpers";
import { seasonShortNames } from "./data";
import { toast } from "react-toastify";
export var DEFAULT_DASHBOARD_ERROR = 'An error occurred. '
    + 'Please try again or contact us at support@tag-walk.com if the problem persists.';
export var noDataAvailable = 'No data available';
export var getSelectTheme = function (theme) {
    return __assign(__assign({}, theme), { colors: __assign(__assign({}, theme.colors), { primary: '#EFF1F1', primary25: '#F8FAFA' }) });
};
export var pillsColors = ['#4fd1c5', '#3bad49', '#de3730', '#7d72ff', '#ffb540', '#40b8ff'];
export var cities = [
    { title: 'Paris', color: "var(--color-dashboard-paris)" },
    { title: 'Milan', color: "var(--color-dashboard-milan)" },
    { title: 'New York', color: "var(--color-dashboard-new-york)" },
    { title: 'London', color: "var(--color-dashboard-london)" },
];
export var updateParamInQuery = function (name, value) {
    var url = new URL(window.location.href);
    url.searchParams.set(name, value);
    history.pushState(null, '', url);
};
export var removeParamInQuery = function (name) {
    var url = new URL(window.location.href);
    url.searchParams.delete(name);
    history.pushState(null, '', url);
};
export var getTooltipAnchor = function (widgetCategory) {
    return widgetCategory === WidgetCategory.MostViewedLooks
        ? 'tooltip-most-viewed-looks'
        : 'tooltip-most-saved-to-moodboard';
};
export var getMVLEndpoint = function (category) {
    if (category === DashboardCategory.Trends) {
        return 'api_dashboard_trend_most_viewed_look_index';
    }
    if (category === DashboardCategory.Brands) {
        return 'api_dashboard_brand_most_viewed_look_index';
    }
    if (category === DashboardCategory.Seasons) {
        return 'api_dashboard_season_most_viewed_look_index';
    }
    return 'api_dashboard_most_viewed_look_index';
};
export var getMSTMEndpoint = function (category) {
    if (category === DashboardCategory.Trends) {
        return 'api_dashboard_trend_most_saved_to_moodboard_index';
    }
    if (category === DashboardCategory.Brands) {
        return 'api_dashboard_brand_most_saved_to_moodboard_index';
    }
    return 'api_dashboard_season_most_saved_to_moodboard_index';
};
export var getCategoryOverviewEndpoint = function (section) {
    if (section === CategoryOverviewSection.RunwayShare) {
        return 'api_dashboard_category_overview_runway_share';
    }
    if (section === CategoryOverviewSection.Moodboards) {
        return 'api_dashboard_category_overview_moodboards';
    }
    return 'api_dashboard_category_overview_searches';
};
export var handleFirstCellValue = function (section) {
    if (section === CategoryOverviewSection.RunwayShare) {
        return 'share_of_collection_v2';
    }
    if (section === CategoryOverviewSection.Searches) {
        return 'search_percentage_v2';
    }
    return 'share_of_moodboards_v2';
};
export var handleSecondCellValue = function (section) {
    if (section === CategoryOverviewSection.RunwayShare) {
        return 'yoy_evol_share_of_collection_v2';
    }
    return 'percentage_evolution_v2';
};
export var getKpiEndpoint = function (category) {
    if (category === DashboardCategory.Trends) {
        return 'api_dashboard_trend_kpi_runway_share_adoption_by_brands';
    }
    if (category === DashboardCategory.Brands) {
        return 'api_dashboard_brand_kpi_index';
    }
    return 'api_dashboard_season_kpi_index';
};
export var handleTop20Arrows = function (value) {
    if (String(value).match(/^-/)) {
        return 'triangle triangle-down';
    }
    if (/^\d/.test(value)) {
        return 'triangle triangle-up';
    }
    return '';
};
export var handleKpiArrows = function (value) {
    if (String(value).match(/^\+/)) {
        return 'triangle triangle-up';
    }
    if (String(value).match(/^-/)) {
        return 'triangle triangle-down';
    }
    if (String(value) === '0%') {
        return 'neutral';
    }
    return '';
};
export var redirectToFocus = function (dashboardCategory, dynamicValue) {
    var _a;
    if (dashboardCategory === DashboardCategory.Brands) {
        window.location.href = generateRoute('data_dashboard_show', {
            slug: 'brand-focus',
            brand: dynamicValue.currentValue
        }, false);
        return;
    }
    if (dashboardCategory === DashboardCategory.Trends) {
        window.location.href = generateRoute('data_dashboard_show', {
            slug: 'trend-focus',
            trend: dynamicValue.currentValue
        }, false);
        return;
    }
    var fullName = (_a = seasonShortNames.find(function (item) { return item.shortName === dynamicValue.currentValue; })) === null || _a === void 0 ? void 0 : _a.name;
    if (!fullName) {
        toast.error(DEFAULT_DASHBOARD_ERROR);
        return;
    }
    window.location.href = generateRoute('data_dashboard_show', {
        slug: 'season-focus',
        season: fullName
    }, false);
};
